import { UnsupportedChainIdError } from "@web3-react/core";
import {
  InjectedConnector,
  NoEthereumProviderError,
} from "@web3-react/injected-connector";
import {
  UserRejectedRequestError,
  WalletConnectConnector,
} from "@web3-react/walletconnect-connector";

export const WalletConnect = new WalletConnectConnector({
  rpc: {
    1: "https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161",
    4: "https://rinkeby.infura.io/v3/84842078b09946638c03157f83405213",
    97: "https://data-seed-prebsc-2-s1.binance.org:8545/",
    56: "https://bsc-dataseed.binance.org/",
    42: "https://kovan.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161",
    137: "https://polygon-rpc.com",
    80001: "https://rpc-mumbai.maticvigil.com/",
  },
  bridge: "https://bridge.walletconnect.org",
  qrcode: true,
  pollingInterval: 12000,
});

export const Injected = new InjectedConnector({
  supportedChainIds: [1, 3, 4, 5, 42, 97, 56, 137, 80001],
});

export const getErrorMessage = (e) => {
  if (e instanceof UnsupportedChainIdError) {
    return "Unsupported Network";
  } else if (e instanceof NoEthereumProviderError) {
    return "No Wallet Found";
  } else if (e instanceof UserRejectedRequestError) {
    return "Wallet Connection Rejected";
  } else if (e.code === -32002) {
    return "Wallet Connection Request Pending";
  } else {
    return "An Error Occurred";
  }
};
